export default {
    namespaced: true,
    state: {
        data: { // my clowder
            members: [],
            allowRequests: false
        },
        otherData: { // When loading other clowder info
            id: 0,
            members: []
        },
        wonders: [],
        loaded: false
    },
    getters: {
        clowder(state) {
            return state;
        }
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        }
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
    }
};